export default class PurchaseReceipt {
  constructor(pr) {

    this.autoRenew = pr.autoRenew;
    this.id = pr.id;
    this.isSubscriptionTrial = pr.isSubscriptionTrial;
    this.pastDue = pr.status === 'past_due';
    this.paymentMethod = pr.paymentMethod;
    this.purchaseOrderId = pr.purchaseOrderId;
    this.trialMode = pr.trialMode;
    this.unrealized = pr.unrealized;

    if (pr.startsAt) {
      this._startsAt = new Date(pr.startsAt);
    }

    if (pr.expiresAt) {
      this._expiresAt = new Date(pr.expiresAt);
    }

  }

  // a subscription is active if the startsAt and expiresAt dates
  // line up correctly, however if they are null then we don't look
  // at those specific dates
  get active() {
    let hasStarted = true;
    let notExpired = true;

    if (this.startsAt) {
      hasStarted = this.startsAt < new Date();
    }

    if (this.expiresAt) {
      notExpired = this.expiresAt > new Date();
    }

    return hasStarted && notExpired;
  }

  // getters/setters are needed when the property is a date object
  // otherwise the date object may accidentally be altered
  get expiresAt() {
    if (this._expiresAt) {
      return new Date(this._expiresAt);
    }
  }

  set expiresAt(date) {
    this._expiresAt = date;
  }

  get startsAt() {
    if (this._startsAt) {
      return new Date(this._startsAt);
    }
  }

  set startsAt(date){
    this._startsAt = date;
  }

}
